import { st, classes } from './responsive.st.css';
export default ({ darkMode }) => st(classes.root, { darkMode });
//# sourceMappingURL=responsive.js.map